export default {
  setSetup(state, setup) {
    state.setup = setup;
  },
  setFaqs(state, faqs) {
    state.faqs = faqs;
  }
};
